import { useState } from 'react';
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import './OrderStatusCard.scss';

const OrderStatusCard = ({ posting, onSubmit }) => {
    const { name, offer_id, posting_number, cancel_reasons, photo, api_id, mp_id } = posting;

    const hasReasons = !!cancel_reasons?.length;

    const [selectedReason, setSelectedReason] = useState(null);
    const [additionalInfo, setAdditionalInfo] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSelectReason = (reason) => {
        setSelectedReason(reason);
        setAdditionalInfo(''); // Сбрасываем доп. информацию при смене причины
    };

    const handleSubmit = () => {
        if (hasReasons) {
            if (!selectedReason) return;
            if (selectedReason.additional_info_required && !additionalInfo.trim()) return;
        }

        onSubmit?.({
            api_id,
            mp_id,
            offer_id,
            posting_number,
            // Причины отмены может не быть — тогда не отправляем связанные поля
            ...(hasReasons && {
                cancel_reason_id: selectedReason.id,
                cancel_reason_message: additionalInfo.trim() || null,
            }),
        });

        setSubmitted(true);
    };

    return (
        <div className={`order-status-card ${submitted ? 'order-status-card--submitted' : ''}`}>
            <div className='order-status-card__product'>
                <div className='order-status-card__photo'>
                    {photo
                        ? <img src={photo} alt={name} />
                        : <span className='order-status-card__photo-placeholder'>Фото</span>
                    }
                </div>
                <div className='order-status-card__product-info'>
                    <p className='order-status-card__name'>{name}</p>
                    <div className='order-status-card__ids'>
                        <span>Арт.: <strong>{offer_id}</strong></span>
                        <span>Отправление: <strong>{posting_number}</strong></span>
                    </div>
                </div>
            </div>

            {!submitted ? (
                <>
                    {hasReasons && (
                        <>
                            <div className='order-status-card__section-label'>Причина отмены</div>
                            <div className='order-status-card__reasons'>
                                {cancel_reasons.map((reason) => (
                                    <label
                                        key={reason.id}
                                        className={`order-status-card__reason-radio ${selectedReason?.id === reason.id ? 'order-status-card__reason-radio--checked' : ''}`}
                                    >
                                        <input
                                            type="radio"
                                            name={`cancel-reason-${posting_number}`}
                                            checked={selectedReason?.id === reason.id}
                                            onChange={() => handleSelectReason(reason)}
                                            className="order-status-card__radio-input"
                                        />
                                        <span className="order-status-card__radio-label">{reason.title}</span>
                                    </label>
                                ))}
                            </div>

                            {selectedReason?.additional_info_required && (
                                <textarea
                                    className='order-status-card__textarea'
                                    placeholder='Укажите дополнительную информацию…'
                                    value={additionalInfo}
                                    onChange={(e) => setAdditionalInfo(e.target.value)}
                                    rows={3}
                                />
                            )}
                        </>
                    )}

                    <ButtonBasic
                        red
                        width='100%'
                        text='Отменить отправление'
                        onClick={handleSubmit}
                        disabled={
                            hasReasons &&
                            (
                                !selectedReason ||
                                (selectedReason.additional_info_required && !additionalInfo.trim())
                            )
                        }
                    />
                </>
            ) : (
                <div className='order-status-card__success'>
                    ✓ Отмена отправлена{selectedReason ? `: «${selectedReason.title}»` : ''}
                </div>
            )}
        </div>
    );
};

export { OrderStatusCard };
